import { useEffect } from 'react'

/**
 * Make the document unscrollable if accept true and fix document width if the scrollbar disappears
 *
 * @param isForbid - should scrolling be forbidden
 */
export const useForbidScroll = (isForbid: boolean) => {
  useEffect(() => {
    const initialWidth = document.documentElement.clientWidth

    if (isForbid) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }

    const currentWidth = document.documentElement.clientWidth

    if (currentWidth > initialWidth) {
      document.body.style.paddingRight = `${currentWidth - initialWidth}px`
    } else {
      document.body.style.paddingRight = ''
    }
  }, [isForbid])
}
